export default {
  signIn: 'Accedi',
  signOut: 'Esci',
  points: 'punti',
  hyattSignInButton: 'Accedi a World of Hyatt',
};
